import {Checkbox, MenuItem, TextField} from '@mui/material'

import {SelectOption} from '../../../common/types'
import {MULTI_SELECT_VALUE_SEPARATOR} from '../../consts'

type MultiSelectProps<TOptionValue extends string | number> = {
  label: string
  options: SelectOption<TOptionValue>[]
  value?: TOptionValue[]
  onChange: (value?: TOptionValue[]) => void
  getOptionLabel?: (option: SelectOption<TOptionValue>) => React.ReactNode
  renderValue?: (args: TOptionValue[]) => React.ReactNode
  translationPrefix?: string
  'data-test-id'?: string
}

export const MultiSelect = <TOptionValue extends string | number>({
  label,
  options,
  value,
  onChange,
  getOptionLabel = ({label}) => label,
  renderValue = (args) => args.join(MULTI_SELECT_VALUE_SEPARATOR),
  'data-test-id': dataTestId
}: MultiSelectProps<TOptionValue>) => {
  return (
    <TextField
      variant="filled"
      data-test-id={dataTestId}
      fullWidth
      label={label}
      onChange={(event) => {
        const val = event.target.value as unknown as TOptionValue[] | undefined
        if (val?.length === 0) onChange(undefined)
        else onChange(val)
      }}
      value={value ?? []}
      SelectProps={{
        multiple: true,
        renderValue: (args) => renderValue(args as TOptionValue[])
      }}
      select
    >
      {options.map((option) => (
        <MenuItem
          data-test-id={`${dataTestId}-${option.value}`}
          key={option.value}
          value={option.value}
        >
          <Checkbox checked={!!value?.includes(option.value)} sx={{mr: 1}} />
          {getOptionLabel(option)}
        </MenuItem>
      ))}
    </TextField>
  )
}
